import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  counts: {}, // { [moduleName]: number }
  loading: false,
};

export const fetchNotificationSummary = createAsyncThunk(
  "notifications/summary",
  async (modules, { dispatch }) => {
    try {
      const response = await axios.post("notification/summary", { modules });
      return response?.data?.data?.counts || {};
    } catch (error) {
      dispatch(fetchError(error));
      return {};
    }
  }
);

export const fetchUnreadCount = createAsyncThunk(
  "notifications/unread-count",
  async (moduleName, { dispatch }) => {
    try {
      const response = await axios.get("notification/unread-count", {
        params: { moduleName },
      });
      return { moduleName, count: response?.data?.data?.count || 0 };
    } catch (error) {
      dispatch(fetchError(error));
      return { moduleName, count: 0 };
    }
  }
);

export const markModuleRead = createAsyncThunk(
  "notifications/mark-read",
  async (moduleName, { dispatch }) => {
    try {
      await axios.post("notification/mark-read", { moduleName });
      return moduleName;
    } catch (error) {
      dispatch(fetchError(error));
      return moduleName;
    }
  }
);

const notificationSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotificationSummary.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchNotificationSummary.fulfilled, (state, action) => {
        state.loading = false;
        state.counts = action.payload || {};
      })
      .addCase(fetchNotificationSummary.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchUnreadCount.fulfilled, (state, action) => {
        const { moduleName, count } = action.payload || {};
        if (moduleName) state.counts[moduleName] = count;
      })
      .addCase(markModuleRead.fulfilled, (state, action) => {
        const moduleName = action.payload;
        if (moduleName) state.counts[moduleName] = 0;
      });
  },
});

export default notificationSlice.reducer;
